var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"radio-invalid"},[_c('b-form-group',{staticClass:"kyc-status-radio overwrite-radio",class:{
            'required-field': _vm.field.isRequired,
        },attrs:{"label":_vm.field.label,"label-for":`id_${_vm.field._id}`}},[_c('b-form-radio-group',{directives:[{name:"validate",rawName:"v-validate",value:({
                required: _vm.field.isRequired,
            }),expression:"{\n                required: field.isRequired,\n            }"}],class:{
                'is-invalid': _vm.errors.has(_vm.field.label),
            },attrs:{"options":_vm.field.options,"name":_vm.field._id,"disabled":_vm.loading,"data-vv-name":_vm.field.label},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }